import { Fonts, FontWeight, HeadingDisplayVariants, HeadingRegularVariants, LineHeights, TextVariants } from "./enums";
const headingStyles = {
    fontFamily: Fonts.display,
    lineHeight: LineHeights.heading
};
export const typeScale = (step) => {
    return Math.pow(1.2, step) + "rem";
};
export const ThemeTextScale = {
    "scale-4": typeScale(-4),
    "scale-3": typeScale(-3),
    "scale-2": typeScale(-2),
    "scale-1": typeScale(-1),
    scale0: typeScale(0),
    scale1: typeScale(1),
    scale2: typeScale(2),
    scale3: typeScale(3),
    scale4: typeScale(4),
    scale5: typeScale(5),
    scale6: typeScale(6),
    scale7: typeScale(7),
    scale8: typeScale(8),
    scale9: typeScale(9),
    scale10: typeScale(10)
};
export const ThemeTextStyles = {
    [HeadingRegularVariants.first]: Object.assign(Object.assign({}, headingStyles), { fontWeight: FontWeight.displayRegular, fontSize: typeScale(5) }),
    [HeadingRegularVariants.second]: Object.assign(Object.assign({}, headingStyles), { fontWeight: FontWeight.displayRegular, fontSize: typeScale(4) }),
    [HeadingRegularVariants.second_and_first]: Object.assign(Object.assign({}, headingStyles), { fontWeight: FontWeight.displayRegular, fontSize: [typeScale(4), null, null, typeScale(5)] }),
    [HeadingRegularVariants.third]: Object.assign(Object.assign({}, headingStyles), { fontWeight: FontWeight.displayRegular, fontSize: typeScale(3) }),
    [HeadingRegularVariants.fourth]: Object.assign(Object.assign({}, headingStyles), { fontWeight: FontWeight.displayRegular, fontSize: typeScale(2) }),
    [HeadingRegularVariants.fifth]: Object.assign(Object.assign({}, headingStyles), { fontWeight: FontWeight.displayRegular, fontSize: typeScale(1) }),
    [HeadingRegularVariants.sixth]: Object.assign(Object.assign({}, headingStyles), { fontWeight: FontWeight.displayRegular, fontSize: typeScale(0) }),
    [HeadingDisplayVariants.first]: Object.assign(Object.assign({}, headingStyles), { fontWeight: FontWeight.displayBold, fontSize: typeScale(5) }),
    [HeadingDisplayVariants.second]: Object.assign(Object.assign({}, headingStyles), { fontWeight: FontWeight.displayBold, fontSize: typeScale(4) }),
    [HeadingDisplayVariants.third]: Object.assign(Object.assign({}, headingStyles), { fontWeight: FontWeight.displayBold, fontSize: typeScale(3) }),
    [HeadingDisplayVariants.fourth]: Object.assign(Object.assign({}, headingStyles), { fontWeight: FontWeight.displayBold, fontSize: typeScale(2) }),
    [HeadingDisplayVariants.fifth]: Object.assign(Object.assign({}, headingStyles), { fontWeight: FontWeight.displayBold, fontSize: typeScale(1) }),
    [HeadingDisplayVariants.sixth]: Object.assign(Object.assign({}, headingStyles), { fontWeight: FontWeight.displayBold, fontSize: typeScale(0) }),
    [TextVariants.technicalParagraphSmall]: {
        fontFamily: Fonts.text,
        fontWeight: FontWeight.textRegular,
        lineHeight: LineHeights.editorial,
        fontSize: typeScale(-1)
    },
    [TextVariants.technicalParagraphLarge]: {
        fontFamily: Fonts.text,
        fontWeight: FontWeight.textRegular,
        lineHeight: LineHeights.editorial,
        fontSize: typeScale(0)
    },
    [TextVariants.editorialParagraphSmall]: {
        fontFamily: Fonts.text,
        fontWeight: FontWeight.textRegular,
        lineHeight: LineHeights.editorial,
        fontSize: typeScale(-1)
    },
    [TextVariants.editorialParagraphLarge]: {
        fontFamily: Fonts.text,
        fontWeight: FontWeight.textRegular,
        lineHeight: LineHeights.editorial,
        fontSize: typeScale(0)
    },
    [TextVariants.quote]: {
        fontFamily: Fonts.display,
        fontWeight: FontWeight.textRegular,
        lineHeight: LineHeights.heading,
        fontSize: typeScale(3)
    },
    [TextVariants.label1]: {
        fontFamily: Fonts.text,
        fontWeight: FontWeight.textRegular,
        lineHeight: LineHeights.label,
        fontSize: typeScale(0)
    },
    [TextVariants.label2]: {
        fontFamily: Fonts.text,
        fontWeight: FontWeight.textRegular,
        lineHeight: LineHeights.label,
        fontSize: typeScale(-1)
    },
    [TextVariants.label3]: {
        fontFamily: Fonts.text,
        fontWeight: FontWeight.textRegular,
        lineHeight: LineHeights.label,
        fontSize: typeScale(-2)
    },
    [TextVariants.label2Bold]: {
        fontFamily: Fonts.text,
        fontWeight: FontWeight.textBold,
        lineHeight: LineHeights.label,
        fontSize: typeScale(-1)
    },
    [TextVariants.label3Bold]: {
        fontFamily: Fonts.text,
        fontWeight: FontWeight.textBold,
        lineHeight: LineHeights.label,
        fontSize: typeScale(-2)
    },
    [TextVariants.deck]: {
        fontFamily: Fonts.text,
        fontWeight: FontWeight.textRegular,
        lineHeight: LineHeights.editorial,
        fontSize: [typeScale(0), null, typeScale(1), typeScale(2)]
    }
};
//# sourceMappingURL=textStyles.js.map